"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledOptionGroup = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const OptionGroup_1 = __importDefault(require("./OptionGroup"));
const constants = __importStar(require("../../search/constants"));
const ControlledOptionGroup = (props) => {
    const { disabled, multiple, value, id, handleComboBoxChange, customComponents, showAny, anyOptionLabel } = props;
    const handleSelected = (key, checked) => {
        if (multiple) {
            if (checked) {
                handleComboBoxChange([...value, ...[key]]);
            }
            else {
                handleComboBoxChange(value.filter(opt => opt !== key));
            }
        }
        else {
            handleComboBoxChange([key]);
        }
    };
    const options = (0, react_1.useMemo)(() => props.options.map(o => ({
        key: o[constants.GuiOptionKey],
        label: o[constants.GuiOptionLabel] || o[constants.GuiOptionKey],
        group: o[constants.GuiOptionGroup] || '',
        customID: o[constants.CustomID],
        checked: value.includes(o[constants.GuiOptionKey]),
        disabled: disabled || !!o[constants.GuiDisabled],
    })), [disabled, props.options, value]);
    const anyChecked = value.includes(constants.SEARCH_ANY_OPTION_KEY);
    const groupProps = {
        customComponents,
        disabled,
        handleSelected,
        id,
        multiple,
        options,
        showAny,
        anyOptionLabel,
        anyChecked,
    };
    return React.createElement(OptionGroup_1.default, Object.assign({}, groupProps));
};
exports.ControlledOptionGroup = ControlledOptionGroup;
exports.default = exports.ControlledOptionGroup;
